const CryptoJS = require("crypto-js");

const encrypt = (key: string, data: any): void => {
	const encryptedMessage = CryptoJS.AES.encrypt(
		JSON.stringify(data),
		process.env.REACT_APP_CRYPTO_JS
	).toString();
	localStorage.setItem(key, encryptedMessage);
};

const decrypt = (key: string): any => {
	let response: any = null;
	const encryptedData: string | null = localStorage.getItem(key);
	if (encryptedData) {
		const bytes = CryptoJS.AES.decrypt(encryptedData, process.env.REACT_APP_CRYPTO_JS);
		response = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
	}
	return response;
};

export const getItem = (key: string): any => decrypt(key);
export const setItem = (key: string, data: any): void => {
	encrypt(key, data);
};
export const deleteItem = (key: string): void => {
	localStorage.removeItem(key);
};
